import { useLocation } from "react-router-dom";

import { ReadCookie, WriteCookie } from "@services/cookie";
import { CookieKeys } from "@config";
import { useEffect } from "react";
import { menus } from "@config/menus";

export const Breadcrumbs = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    const routeHistory = ReadCookie(CookieKeys.HISTORY);
    if (
      pathname !== "/" &&
      pathname !== "/error404" &&
      Object.values(menus).find((rName: any) => rName.path === pathname)?.title
    ) {
      let routeHistoryArr: any = routeHistory ? routeHistory : [];

      if (routeHistoryArr.length) {
        if (routeHistoryArr[routeHistoryArr.length - 1] !== pathname) {
          routeHistoryArr.push({ pathname, domain: "FCSS" });
        }
      } else {
        routeHistoryArr.push({ pathname: pathname, domain: "FCSS" });
      }

      WriteCookie(CookieKeys.HISTORY, routeHistoryArr.slice(-5));
    }
  }, [pathname]);

  return <></>;
};
